module.exports = __webpack_public_path__ + "img/2I.8fbd8d2e.png";